import i18n from '@packages/core/i18n'
import { initReactI18next } from 'react-i18next'
import {
  createI18nBackend,
  createLocaleRegistry
} from '@packages/utils/i18n'
import { aiLocaleManifest } from '@packages/ai/locales/manifest'

/**
 * Admin app i18n bootstrap. Admin's own strings live inline as
 * `defaultValue` on `t()` calls, so the default `translation`
 * namespace has no catalogue. The `ai` namespace is the only package
 * catalogue consumed by admin today (see `app/schemas/index.tsx`).
 */
export const adminLocaleRegistry = createLocaleRegistry([aiLocaleManifest])

void i18n
  .use(initReactI18next)
  .use(createI18nBackend(adminLocaleRegistry))
  .init({
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation'],
    interpolation: { escapeValue: false },
    returnNull: false
  })

export default i18n
